import React, { useState } from "react";
import { Link } from "react-router-dom";
import CatalogueNavbar from "../../components/CatalogueNavbar";
import FooterCatalogue from "../../components/FooterCatalogue";
export default function ProductPage() {
  // Product spec array start
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const fabricData = [
    {
      iconUrl: "/icons_Products/Fabrics/FabricType.svg",
      topic: "Fabric Type",
      contentArray: [
        "100% Cotton",
        "100% Supima Cotton",
        "Cotton Poly Blends",
        "Cotton Spandex Blend",
      ],
    },
    {
      iconUrl: "/icons_Products/Fabrics/FabricType.svg",
      topic: "GSM",
      contentArray: ["140 to 260 gsm"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Size.svg",
      topic: "Sizes",
      contentArray: ["XS,S,M,L,XL,2XL,3XL,4XL"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/MOQ.svg",
      topic: "Minimum Order Quantity",
      contentArray: ["300 Pieces per Style"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Sample.svg",
      topic: "Production Certifications",
      contentArray: ["GOTS"],
    },

    {
      iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
      topic: "Order lead time",
      contentArray: ["Order Basis"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/PPSample.svg",
      topic: "PP Sample Lead Time",
      contentArray: ["Order Basis"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Sample.svg",
      topic: "Sample making",
      contentArray: ["Yes, available."],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Customize.svg",
      topic: "Customization",
      contentArray: ["Yes"],
    },

    {
      iconUrl: "/icons_Products/Fabrics/BulkLead.svg",
      topic: "Bulk Lead Time",
      contentArray: ["Order Basis"],
    },
  ];

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
  // Product spec array end

  // Fabric composition start
  const contentArray = [
    {
      imageUrl: "../../Garments/Tshirts/7.png",
      content: <p className="text-center font-bold">Printed</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/6.png",
      content: <p className="text-center font-bold">Zipper</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/5.png",
      content: <p className="text-center font-bold">Oversized</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/4.png",
      content: <p className="text-center font-bold">Mandarin Polo</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/3.png",
      content: <p className="text-center font-bold">Henley</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/2.png",
      content: <p className="text-center font-bold">Dropcut</p>,
    },
    {
      imageUrl: "../../Garments/Tshirts/1.png",
      content: <p className="text-center font-bold">Bomber</p>,
    },
  ];

  // Fabric composition end

  // Discover more start
  const contentArray1 = [
    {
      imageUrl: "/fabrics/Jacquard.png",
      content: <p className="text-center font-semibold">Jacquard</p>,
      redirectUrl: "/Fabrics/Jacquard",
    },
    {
      imageUrl: "../../FabricCat/18.png",
      content: <p className="text-center font-semibold">Ottoman</p>,
      redirectUrl: "/Fabrics/Ottoman",
    },
    {
      imageUrl: "../../FabricCat/16.png",
      content: <p className="text-center font-semibold">Waffle</p>,
      redirectUrl: "/Fabrics/Waffle",
    },
    {
      imageUrl: "../../FabricCat/Slub.jpg",
      content: <p className="text-center font-semibold">SlubKnit</p>,
      redirectUrl: "/Fabrics/SlubKnit",
    },
  ];
  // Discover more end

  return (
    <div className="font-Manrope">
      <CatalogueNavbar />
      {/* Banner start */}

      <div
        className="h-[20vh] md:h-[50vh] bg-cover bg-center relative"
        style={{ backgroundImage: "url('/FabCatbanner.png')" }}
      >
        {/* Inner div positioned at the bottom left corner */}
        <div className="absolute bottom-[2vh] md:bottom-[10vh] left-[2vh] md:left-[10vh] p-3 text-white text-4xl">
          {/* Inner content here */}
          <p>
            <span className="font-bold text-2xl md:text-5xl">
              <a href="/Garments">Garments</a> .{" "}
              <a href="/Garments/TShirt">T-Shirt</a>
            </span>
          </p>
        </div>
      </div>
      {/* Banner end */}
      <div className="p-10 ">
        {/* Image Gallery start */}
        <div className="relative h-auto  flex md:flex-row flex-col  ">
          {/* Left Column (45% width) */}
          <div className="hidden   md:block md:w-[45%]">
            <ImageGallery />
          </div>
          <div className="block md:hidden md:w-[45%]">
            <ImageGallery1 />
          </div>
          {/* Right Column (55% width) - content placeholder */}
          <div className="w-full md:w-[55%] md:pt-0 pt-3 pl-0 md:pl-8 ">
            <h2 className="text-xl font-semibold  mb-2">T-Shirts</h2>
            <p className="text-sm text-[#666666]">
              Our T-shirts elevate everyday wear with unmatched comfort and
              sophisticated style. Expertly knitted from the finest yarns, they
              offer a superior fit, lasting durability, and sleek design.
              Precision stitching and refined details ensure versatility,
              blending timeless simplicity with modern appeal for every
              occasion.
            </p>
            <div className="mt-4 text-[#666666] flex flex-row">
              Customization
            </div>
            <div className="flex flex-row space-x-2 items-center">
              <span>Any print, Solids, Striper, Blended Knits</span>
            </div>
            <div className="mt-4 text-black flex flex-col">
              <div className="font-semibold">Our garment finishes</div>
              <div className="">
                Bio-Washed, Mercerized, Gold Finish (Soft hand feel), Water
                Repellent, Anti-Bacterial, Wicking, UV Protection, Flame
                Retardant, Anti-Static, Moisture Management, Stretch Recovery.
              </div>
            </div>
            <div className="container mx-auto mt-6 md:mt-8">
              <button className="w-full bg-transparent border-2 border-[#465B83] text-[#000000]  rounded-full">
                Get in touch
              </button>
            </div>
          </div>
        </div>
        {/* Image Gallery end */}
        {/* product spec start */}
        <div className="mt-10  md:px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3  font-brygada">
          {fabricData.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center bg-white pl-0 pr-0 md:pl-4 md:pr-4 p-3  space-x-1 w-full"
            >
              <div className="flex-none  pr-2 ">
                <img
                  src={item.iconUrl}
                  alt={`${item.topic} Icon`}
                  className="h-12 w-12"
                />
              </div>
              <div className="flex-grow   flex flex-col items-start justify-between">
                <div className="font-bold text-[#242424]">{item.topic}</div>
                {item.contentArray.length > 1 ? (
                  <div className="relative w-full text-[#6B6B6B]">
                    <button
                      onClick={() => toggleDropdown(index)}
                      className="text-black  mt-1 w-full flex flex-row text-left relative"
                    >
                      {item.contentArray[0]}
                      <span className="relative ml-2 mt-1">
                        <svg
                          className="w-4 h-4 fill-current"
                          viewBox="0 0 20 20"
                        >
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </span>
                    </button>
                    {openDropdownIndex === index && (
                      <ul className="origin-top absolute mt-1 w-full bg-white shadow-lg rounded-md overflow-hidden z-10">
                        {item.contentArray.map((content, idx) => (
                          <li
                            key={idx}
                            className="p-2 hover:bg-gray-100 cursor-pointer text-left"
                          >
                            {content}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <div className="mt-1 text-left w-full">
                    {item.contentArray[0]}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* product spec end */}
        {/* Fabric composition/blends start */}
        <div className="mt-5 mb-2 font-brygada font-semibold text-[#242424] flex items-center justify-center text-2xl">
          Our T-Shirt Collections
        </div>

        <div className="w-full mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:p-4">
          {contentArray.map((item, index) => (
            <div key={index} className="flex flex-col items-center bg-white ">
              <img
                src={item.imageUrl}
                alt={`Description ${index + 1}`}
                className=" w-full md:w-[90%] mx-auto object-cover rounded-lg h-[35vh] md:h-[55vh]" // Ensuring the image covers the div and has rounded top corners
              />
              <div className="p-2 md:p-4 text-lg">{item.content}</div>
            </div>
          ))}
        </div>
        {/* Fabric composition/blends end */}

        <div className="mt-4 px=6 md:px-12">
          * Designs in our digital catalogue is only a glimpse, our
          possibilities are endless! We have an exceptional
          <strong> in-house design team</strong> eager to partner up, turning
          ideas into standout designs or crafting something extraordinary that
          amplifies the brand story. {/* Get in touch start */}
          <div className=" inline text-black   underline mt-2">
            <a href="/Catalogue#ContactUs">
              Get in touch with our expert Garment and Fabric consultants.
            </a>
          </div>
          {/* Get in touch end */}
        </div>
      </div>
      <FooterCatalogue />
    </div>
  );
}

function ImageGallery() {
  // Using Waffle images
  const images = [
    "../../Garments/Tshirts/1.png ",
    "../../Garments/Tshirts/2.png ",
    "../../Garments/Tshirts/7.png ",
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 3;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const isThreeOrFewerImages = images.length <= 3;

  return (
    <div className="h-full">
      <div className="flex h-full">
        <div className="flex flex-col items-center pl-6 pr-4 h-full">
          {!isThreeOrFewerImages && (
            <button
              onClick={handlePrev}
              disabled={startIndex === 0}
              className="disabled:opacity-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 15l-6-6-6 6" />
              </svg>
            </button>
          )}
          <div
            className={`flex flex-col overflow-hidden ${
              isThreeOrFewerImages ? "justify-center h-[95%]" : "h-[95%]"
            }`}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`w-20 h-20 object-cover cursor-pointer mb-2 rounded-xl border ${
                      selectedIndex === actualIndex
                        ? "border-blue-500"
                        : "border-transparent"
                    }`}
                  />
                );
              })}
          </div>
          {!isThreeOrFewerImages && (
            <button
              onClick={handleNext}
              disabled={startIndex + THUMBNAILS_PER_VIEW >= images.length}
              className="disabled:opacity-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
          )}
        </div>
        <div className="flex-1 h-[65vh]">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>
      </div>
    </div>
  );
}

function ImageGallery1() {
  const images = [
    "../../Garments/Tshirts/1.png ",
    "../../Garments/Tshirts/2.png ",
    "../../Garments/Tshirts/7.png ",
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 4;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const hasMoreThumbnails = images.length > THUMBNAILS_PER_VIEW;
  const isLeftArrowActive = startIndex > 0;
  const isRightArrowActive = startIndex + THUMBNAILS_PER_VIEW < images.length;

  return (
    <div className="h-[50vh] w-full ">
      <div className="flex flex-col h-[50vh] w-full">
        <div className="flex-1 h-[50%] w-full mb-0 md:mb-4">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>
        <div className="flex items-center justify-center mt-0 md:mt-4 w-full h-[10vh] relative">
          {hasMoreThumbnails && (
            <button
              onClick={handlePrev}
              disabled={!isLeftArrowActive}
              className={`absolute left-0 z-10 ${
                isLeftArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
          )}
          <div
            className="flex items-center justify-start overflow-x-hidden w-[90%] mx-auto"
            style={{ scrollBehavior: "smooth" }}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`ml-2 w-1/4 h-12 object-cover cursor-pointer mx-1 rounded-xl border ${
                      selectedIndex === actualIndex
                        ? "border-blue-500"
                        : "border-transparent"
                    }`}
                  />
                );
              })}
          </div>
          {hasMoreThumbnails && (
            <button
              onClick={handleNext}
              disabled={!isRightArrowActive}
              className={`ml-3 absolute right-0 z-10 ${
                isRightArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
